<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-2 sdbr">
        <Sidebar />
      </div>
      <div class="col-sm-10">
        <div class="row d-flex justify-content-center p-4 mt-4">
          <div class="col-sm-4 searchbar p-1">
            <input
              class="form-control"
              type="search"
              aria-label="Search through site content"
              :placeholder="placeholder"
              v-model="search"
            />
          </div>
          <div
            class="col-sm-1 btn btn-primary text-center p-1 m-1"
            @click="getUser"
          >
            Search
          </div>
          <div
            class="col-sm-1 btn btn-primary text-center p-1 m-1"
            @click="clearSearch"
          >
            Clear
          </div>
        </div>
        <div class="row shdw brdrad" v-if="userData.email">
          <div class="col-sm-12 p-3">
            <div class="row">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Email</th>
                    <!-- <th scope="col">Key</th> -->
                    <th scope="col">Plan</th>
                    <th scope="col">Company</th>
                    <th scope="col">Call Limit</th>
                    <th scope="col">Limit type</th>
                    <th scolpe="col">Onboarding Date</th>
                    <th scolpe="col" v-if="!this.userData.unlimited">Limit End Date</th>
                  </tr>
                </thead>
                <tbody class="tab-data">
                  <tr>
                    <td>{{ userData.email }}
                    <!-- <td> -->
                      <small>{{ userData.key ? userData.key : "" }}</small>
                    </td>
                    <td>{{ getUserPlan(userData) }}</td>
                    <td>{{ userData.company }}</td>
                    <td>{{ userData.limit }}</td>
                    <td>{{ userData.monthlyLimit ? "Monthly" : "Daily" }}</td>
                    <td>{{ userData.onboardingDate }}</td>
                    <td v-if="!this.userData.unlimited">{{ userData.limitEndDate}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row pt-3">
              <div class="col-sm-12 h4 text-center">
                <div class="row">
                  <div class="col-sm-12">Update Limit</div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-4 offset-md-4 pb-3">
                    Set limit type
                    <select
                      class="custom-select"
                      v-model="duration"
                      @click="setLimit(duration)"
                    >
                      <option value="d" selected>Daily limit</option>
                      <option value="m">Monthly limit</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-4 offset-md-4 pb-3">
                    <input
                      class="form-control"
                      placeholder="set limit value"
                      type="text"
                      v-model="limit"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="row d-flex justify-content-center">
                  <div class="col-sm-4 pb-3">
                    Unlimited:
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="inlineRadioOptions"
                        id="inlineRadio1"
                        value="one"
                        v-model="unlimited"
                      />
                      <label class="form-check-label" for="inlineRadio1"
                        >True</label
                      >
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="inlineRadioOptions"
                        id="inlineRadio2"
                        value="two"
                        v-model="unlimited"
                      />
                      <label class="form-check-label" for="inlineRadio2"
                        >False</label
                      >
                    </div>
                    <div 
                    class="row d-flex justify-content-left py-3"
                    v-if="unlimited === 'two'"
                    >Set End Date
                      <date-picker
                        v-model="limitEnd"
                        type="datetime"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="row d-flex justify-content-center">
                  <div
                    class="col-sm-4 btn btn-success"
                    @click="updateLimit(userData, limit)"
                  >
                    Update
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row d-flex justify-content-center pt-5"> -->
            <div class="row d-none justify-content-center pt-5">
              <div class="col-sm-12 h4 text-center">Reset User</div>
              <div class="col-sm-12 text-center py-3">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                The user's api calls will be reset to 0
              </div>
              <div
                class="col-sm-2 btn btn-danger"
                @click="resetWarn(userData.key)"
              >
                Reset User
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Sidebar from "./sidebar";
import Searchbox from "../devices/Searchbox";
import swtAlrt from "../../mixins/swtalrt";
import Swal from "sweetalert2";
import moment from "moment";
export default {
  data() {
    return {
      placeholder: "Search user by key or email Id",
      search: "",
      limit: "",
      currLimit: "",
      userData: {},
      duration: "",
      limitEnd: "",
      unlimited: "",
      monthlimit: false,
    };
  },
  components: {
    Sidebar,
    Searchbox,
    DatePicker,
  },
  mixins: [swtAlrt],
  methods: {
    setLimit(type) {
      if (type === "d") this.monthlimit = false;
      else this.monthlimit = true;
    },
    resetWarn(userKey) {
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this! User will be reset.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Update!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.resetUser(userKey);
          Swal.fire("Updated!", "Reset successful", "success");
        }
      });
    },
    getUser() {
      const apiUri = `http://13.235.254.91:5000/apiuser/user-by-ip?ip=${this.search}`;
      // const apiUri = `http://localhost:3002/apiuser/user-by-ip?ip=${this.search}`;
      const options = {
        url: apiUri,
        method: "GET",
      };
      this.$http(options)
        .then((result) => {
          let data = result.data.data[0];
          this.currLimit = data.limit;
          this.userData = {
            name: data.name,
            email: data.email,
            limit: data.limit,
            key: data.aws_key.value,
            company: data.company || "NA",
            onboardingDate: moment(data.aws_key.createdDate).format(
              "Do MMM YYYY"
            ),
            planId: data.planId,
            monthlyLimit: data.monthlyLimit,
            limitEndDate:data.limitEndDate ? moment(data.limitEndDate).format(
              "Do MMM YYYY") : 'NA',
            unlimited : data.unlimited
          };
        })
        .catch((e) => {
          console.log("user not found", e);
          this.swalSearchError();
        });
    },
    updateLimit(userData, limit) {
      const apiUri = `http://13.235.254.91:5000/apiuser/update`;
      // const apiUri = `http://localhost:3002/apiuser/update`;
      if (limit > 100) {
        let objData = {
          key: userData.key,
          limit: limit,
          monthlyLimit: this.monthlimit,
          unlimited : this.unlimited === "one" ? true : false,
          limitEndDate : this.unlimited === "two" ? moment(this.limitEnd, 'YYYY-MM-DD').format(): '' ,
          poc: true,
        };
        const options = {
          url: apiUri,
          method: "POST",
          data: objData,
        };
        this.$http(options)
          .then((result) => {
            this.getUser();
            this.swalLimitUpdateSuccess();
          })
          .catch((err) => console.log(err));
      } else if (limit == 100) {
        let objData = {
          key: userData.key,
          limit: limit,
          monthlyLimit: this.monthlimit,
          poc: false,
        };
        const options = {
          url: apiUri,
          method: "POST",
          data: objData,
        };
        this.$http(options)
          .then((result) => {
            this.getUser();
            this.swalLimitUpdateSuccess();
          })
          .catch((err) => console.log(err));
      } else {
        this.swalLimitError();
      }
    },
    getUserPlan(userInfo) {
      if (!userInfo) {
        return "Custom";
      } else if (userInfo.planId === "obalx7") {
        return "Free";
      } else if (userInfo.planId === "zz5dnf" || userInfo.planId === "NA") {
        return "Custom";
      } else {
        return "Pay as you go";
      }
    },
    clearSearch() {
      this.search = "";
      this.placeholder = "Search user by key or email Id";
    },
    resetUser(userKey) {
      let startDt = moment().startOf("day").utc().format("YYYY-MM-DD HH:mm:ss");
      let objData = {
        dt: startDt,
        token: userKey,
      };
      const apiUri = `http://13.235.254.91:5000/apiuser/reset`;
      // const apiUri = `http://localhost:5000/apiuser/reset`;
      const options = {
        url: apiUri,
        method: "POST",
        data: objData,
      };
      this.$http(options)
        .then((result) => {})
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style>
.mx-datepicker,
.mx-datepicker-range {
  width: 20rem;
  height: calc(1.5em + 0.75rem + 2px);
}
</style>